/**
 * Helper para gerar um blob URL autenticado para preview inline em iframe.
 * Retorna objectUrl + filename. Caller deve revogar o objectUrl ao fechar.
 */
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export async function fetchPdfBlobUrl(path, errorMsg = 'Erro ao carregar PDF') {
  try {
    const token = localStorage.getItem('nautilus_token');
    const url = `${API}/api${path.startsWith('/') ? '' : '/'}${path}`;
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) throw new Error('falha');
    const blob = await r.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    toast.error(errorMsg);
    return null;
  }
}
